export default __webpack_public_path__ + "static/media/nailed-it.d0ec9f46.gif";